import axiosInstance from "../../services/server/axios";

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};

export const getDashboardStats = async () => {
  const response = await axiosInstance.get('/dashboard', {
    headers: getAuthHeaders(),
  });
  return response.data;
};